import { createApp } from 'vue'
import Maska from 'maska'
import { svgSpritePlugin } from 'vue-svg-sprite'
import App from './App.vue'
import addMountBlock from './core/appMountBlock'
import replaceAppToEnd from '@/core/replaceAppToEnd'
import Api from './core/api'

// let curLoc = location.pathname

Api
  .getInitData(window.location.host)
  .then(({ data }) => {
    if (Array.isArray(data) && data.length) {
      data.forEach(el => {
        const app = createApp(App)
          .use(Maska)
          .use(svgSpritePlugin, { path: '/assets/icons/sprite' })
        const mountF = () => {
          app.config.globalProperties.initData = el
          addMountBlock(el.widgetInfo?.pluggableSelector, el.openInfo.type, el.openInfo?.settings?.elemClass || null)
          app.mount(`#${el.widgetInfo?.pluggableSelector || 'quiz-widget'}`)
        }
        mountF()
      })
    } else {
      const app = createApp(App)
        .use(Maska)
        .use(svgSpritePlugin, { path: '/assets/icons/sprite' })
      app.config.globalProperties.initData = data
      addMountBlock(data.widgetInfo?.pluggableSelector, data.openInfo.type, data.openInfo?.settings?.elemClass || null)
      app.mount(`#${data.widgetInfo?.pluggableSelector || 'quiz-widget'}`)
      replaceAppToEnd(data.widgetInfo?.pluggableSelector)
    }
  }).catch(error => {
    console.error(error)
  })
